module.exports = __webpack_public_path__ + "img/Feature.de113ff3.png";